<template>
  <div :class="['rb-pup', { 'rb-active': active, 'rb-on-screen': onScreen }]">
    <div
      class="rb-pup-overlay"
      @click.prevent="notifyClose"
      :id="`overlay-close-${slugify(title)}`"
    ></div>
    <div class="rb-pup-wrap">
      <div class="rb-top">
        <div class="rb-top-content">
          <h2>{{ title }}</h2>
          <button
            aria-label="Close Popup"
            @click.prevent="notifyClose"
            :id="`btn-close-${slugify(title)}`"
          >
            <icon-close />
          </button>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
/**
 * Basic layout for Popups
 *
 * @props
 * active: Boolean
 * onScreen: Boolean
 * title: String
 *
 * @implements
 * TrackMixin
 *
 * @emits
 * close
 */
import TrackMixin from "@/mixins/TrackMixin";
import IconClose from "@/components/icons/IconClose";
import { slugify } from "@/lib";
export default {
  mixins: [TrackMixin],
  components: { IconClose },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    onScreen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    notifyClose: function (event) {
      this.$emit("close");
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    slugify: function (str) {
      return slugify(str);
    },
  },
};
</script>
